import React from "react";

import Skeleton from "@mui/material/Skeleton";

export default function CampaignCoverSkeleton() {
    return <Skeleton height={443} variant="rectangular" />
}